import { createTheme, type Theme } from '@mui/material/styles';
import { ptBR as ptBRCore } from '@mui/material/locale';
import { ptBR as ptBRDataGrid } from '@mui/x-data-grid/locales';

/** Tema MUI alinhado aos tokens do design system (uso residual: DataGrid). */
export function createAppTheme(): Theme {
  return createTheme(
    {
      palette: {
        mode: 'light',
        primary: { main: '#6A2ED3' },
        secondary: { main: '#6A2ED3' },
        background: {
          default: '#F7F9FB',
          paper: '#FFFFFF'
        },
        text: {
          primary: '#3A3A3A',
          secondary: '#8D8D8D'
        },
        success: { main: '#3DB34D' },
        warning: { main: '#A65C00' },
        error: { main: '#CC3A3D' },
        divider: '#E0E0E0'
      },
      shape: { borderRadius: 12 },
      typography: {
        fontFamily: '"Inter", sans-serif',
        h4: { fontWeight: 700 },
        h5: { fontWeight: 700 },
        h6: { fontWeight: 600 }
      },
      components: {
        MuiButtonBase: {
          defaultProps: { disableRipple: true }
        }
      }
    },
    ptBRCore,
    ptBRDataGrid
  );
}
